export default {
  SET_SERVICE_PRICE(state, payload) {
    state.servicePrice = payload;
  },
  SET_SERVICE_PRICE_PAYLOAD(state, payload) {
    state.servicePricePayload = payload;
  },
};
